/**
 * Dealer Website - Main JavaScript
 * ===================================
 * Handles: navigation, search tabs, scroll behavior, vehicle cards
 */

/* =========================================
   NAVIGATION
   ========================================= */
function initNav(): void {
  const hamburger = document.querySelector<HTMLElement>('.hamburger');
  const mobileNav = document.querySelector<HTMLElement>('.mobile-nav');
  const mobileClose = document.querySelector<HTMLElement>('.mobile-nav-close');

  function closeMobileNav(): void {
    mobileNav?.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', closeMobileNav);
  }

  // Close on overlay click
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) closeMobileNav();
    });
  }

  // Active nav link based on current page. Compare resolved pathnames: with <base href="/">
  // and pages at two depths, comparing the raw href to the last path segment no longer matches.
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/index.html';
  document.querySelectorAll<HTMLAnchorElement>('.nav-list a, .mobile-nav a').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
    if (linkPath === currentPath) {
      link.classList.add('active');
    }
  });
}

/* =========================================
   SEARCH TABS (New / Used / Certified)
   ========================================= */
function initSearchTabs(): void {
  const tabs = document.querySelectorAll<HTMLElement>('.search-tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });
}

/* =========================================
   SCROLL BEHAVIOR
   ========================================= */
function initScrollBehavior(): void {
  const scrollBtn = document.querySelector<HTMLElement>('.scroll-top');
  if (!scrollBtn) return;

  window.addEventListener(
    'scroll',
    () => {
      if (window.scrollY > 400) {
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
    },
    { passive: true },
  );

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/* =========================================
   VEHICLE CARDS - Compare
   ========================================= */
function initVehicleCards(): void {
  // Category card clicks
  document.querySelectorAll<HTMLElement>('.category-card').forEach((card) => {
    card.addEventListener('click', () => {
      const type = card.dataset.type || '';
      window.location.href = `inventory.html?type=${encodeURIComponent(type)}`;
    });
  });
}

/* =========================================
   DOM READY
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initSearchTabs();
  initScrollBehavior();
  initVehicleCards();
});
